import { changeLanguage } from "../utils/GeneralUtils.ts";
import type { Language } from "../types/PersologOnlineTypes.ts";

/**
 * Public pages support a `?language=de|en` deep link, so marketing can link straight to a page in a
 * given language without the visitor having to switch it (an anonymous visitor has no stored
 * preference beyond localStorage). Anything else is ignored, leaving the stored/default locale alone.
 */
export const PUBLIC_LOCALES: Language[] = ["de", "en"];

/** True when [value] is a locale the public pages offer. */
export function isPublicLocale(value: unknown): value is Language {
    return typeof value === "string" && (PUBLIC_LOCALES as string[]).includes(value);
}

/**
 * Applies `?language=` from a route query, if it names a supported locale.
 * Returns the locale that was applied, or null when the query asked for nothing usable.
 */
export function useLocaleFromQuery(query: Record<string, unknown> | undefined): Language | null {
    const requested = query?.language;
    if (!isPublicLocale(requested)) return null;
    changeLanguage(requested);
    return requested;
}
